/**
 * Русские названия и описания для таблиц контента (src/data/*.ts).
 * Ключ — английский текст из { zh, en }: так таблицы данных не пришлось менять.
 * Чего здесь нет, в русском интерфейсе показывается по-английски.
 */
export const RU_DATA: Record<string, string> = {
  // ── материалы
  'Beast Bone': 'Звериная кость',
  'Scale': 'Чешуя',
  'Wolf Fang': 'Волчий клык',
  'Thick Fur': 'Густой мех',
  'Coral Core': 'Коралловое ядро',
  'Dragon Scale': 'Драконья чешуя',
  'Patterned Shell': 'Узорчатая ракушка',
  'Sea Pearl': 'Морская жемчужина',
  'Isle Amber': 'Островной янтарь',

  // ── растения: семена и урожай
  'Carrot Seed': 'Семена моркови', 'Carrot': 'Морковь',
  'Potato Seed': 'Семена картофеля', 'Potato': 'Картофель',
  'Strawberry Seed': 'Семена клубники', 'Strawberry': 'Клубника',
  'Corn Seed': 'Семена кукурузы', 'Corn': 'Кукуруза',
  'Tomato Seed': 'Семена помидора', 'Tomato': 'Помидор',
  'Cabbage Seed': 'Семена капусты', 'Cabbage': 'Капуста',
  'Pineapple Seed': 'Семена ананаса', 'Pineapple': 'Ананас',
  'Eggplant Seed': 'Семена баклажана', 'Eggplant': 'Баклажан',
  'Pumpkin Seed': 'Семена тыквы', 'Pumpkin': 'Тыква',
  'Isle Chili Seed': 'Семена островного чили', 'Isle Chili': 'Островной чили',
  'Watermelon Seed': 'Семена арбуза', 'Watermelon': 'Арбуз',
  'Rice Seed': 'Семена риса', 'Rice': 'Рис',
  'Taro Seed': 'Семена таро', 'Taro': 'Таро',
  'Orchid Seed': 'Семена орхидеи', 'Orchid': 'Орхидея',
  'Sugarcane Seed': 'Семена сахарного тростника', 'Sugarcane': 'Сахарный тростник',
  'Cacao Seed': 'Семена какао', 'Cacao': 'Какао',
  'Isle Ginseng Seed': 'Семена островного женьшеня', 'Isle Ginseng': 'Островной женьшень',
  'Starfruit Seed': 'Семена карамболы', 'Starfruit': 'Карамбола',
  'Banana Tree Seed': 'Саженец банана', 'Banana Tree': 'Банановое дерево',
  'Coconut Palm Seed': 'Саженец кокосовой пальмы', 'Coconut Palm': 'Кокосовая пальма',
  'Apple Tree Seed': 'Саженец яблони', 'Apple Tree': 'Яблоня',
  'Lemon Tree Seed': 'Саженец лимона', 'Lemon Tree': 'Лимонное дерево',
  'Mango Tree Seed': 'Саженец манго', 'Mango Tree': 'Манговое дерево',
  'Lychee Tree Seed': 'Саженец личи', 'Lychee Tree': 'Дерево личи',
  'Peach Tree Seed': 'Саженец персика', 'Peach Tree': 'Персиковое дерево',
  'Gold Fruit Tree Seed': 'Саженец золотого дерева', 'Gold Fruit Tree': 'Золотое плодовое дерево',

  // ── продукция животных
  'Egg': 'Яйцо',
  'Duck Egg': 'Утиное яйцо',
  'Angora Wool': 'Ангорская шерсть',
  'Goat Milk': 'Козье молоко',
  'Truffle': 'Трюфель',
  'Fleece': 'Шерсть',
  'Milk': 'Молоко',
  'Turkey Plume': 'Индюшиное перо',
  'Alpaca Fiber': 'Волокно альпаки',
  'Peacock Feather': 'Павлинье перо',

  // ── рыба
  'Sardine': 'Сардина',
  'Anchovy': 'Анчоус',
  'Mackerel': 'Скумбрия',
  'Crucian Carp': 'Карась',
  'Goby': 'Бычок',
  'Smelt': 'Корюшка',
  'Glass Shrimp': 'Стеклянная креветка',
  'Moon Clam': 'Лунная ракушка',
  'Sea Bream': 'Морской лещ',
  'Flounder': 'Камбала',
  'Glow Squid': 'Светящийся кальмар',
  'Pufferfish': 'Иглобрюх',
  'Blue Lobster': 'Синий омар',
  'Isle Eel': 'Островной угорь',
  'King Grouper': 'Королевский групер',
  'Swordfish': 'Меч-рыба',
  'Hawksbill': 'Черепаха-бисса',
  'Violet Ray': 'Фиолетовый скат',
  'Lionfish': 'Крылатка',
  'Azure Marlin': 'Лазурный марлин',
  'Ocean Sunfish': 'Рыба-луна',
  'Ghost Lantern': 'Призрачный фонарик',
  'Kraken Jr.': 'Малыш-кракен',
  'Gilded Koi': 'Золотой карп кои',
  'Its shell looks like a treasure map.': 'Узор на панцире похож на карту сокровищ.',
  'It sunbathes lazily; reeling it in is a workout.': 'Лениво греется на солнце, а вытащить её — настоящая тренировка.',
  'The legendary lord of the deep... as a baby.': 'Легендарный повелитель глубин… в детстве.',
  'Seeing one brings luck. Catching one means you already have it.': 'Кто увидит её, тому повезёт. Кто поймает — тому уже повезло.',

  // ── животные
  'Hen': 'Курица',
  'Duck': 'Утка',
  'Wool Rabbit': 'Ангорский кролик',
  'Dairy Goat': 'Молочная коза',
  'Spotted Pig': 'Пятнистая свинья',
  'Sheep': 'Овца',
  'Cow': 'Корова',
  'Turkey': 'Индейка',
  'Alpaca': 'Альпака',
  'Peacock': 'Павлин',

  // ── звери-захватчики
  'Bush Boar': 'Кустарниковый кабан',
  'Mischief Monkey': 'Обезьяна-проказница',
  'Dappled Python': 'Пятнистый питон',
  'Seawind Wolf': 'Волк морского ветра',
  'Mudflat Croc': 'Крокодил отмелей',
  'Isle Bear': 'Островной медведь',
  'Coral Golem': 'Коралловый голем',
  'Mist Isle Dragon': 'Дракон туманного острова',

  // ── постройки и украшения
  'Thatch Hut': 'Соломенная хижина',
  'Log Cabin': 'Бревенчатый домик',
  'Beach House': 'Пляжный домик',
  'Palm Villa': 'Вилла среди пальм',
  'Lighthouse': 'Маленький маяк',
  'Coral Castle': 'Коралловый замок',
  'Wood Fence': 'Деревянный забор',
  'Flower Bed': 'Клумба',
  'Bench': 'Скамейка',
  'Gourd Lamp': 'Тыквенный фонарь',
  'Wishing Well': 'Колодец желаний',
  'Dolphin Fountain': 'Фонтан с дельфином',
  'Palm Swing': 'Качели на пальме',
  'Beach Parasol': 'Пляжный зонт',
  'Sand Castle': 'Замок из песка',
  'Sea God Statue': 'Статуя морского бога',
  'Vine Archway': 'Арка из лоз',
  'Windmill': 'Ветряная мельница',
  'Echo Conch': 'Говорящая раковина',
  'Bonfire': 'Костёр',
  'Tiki Totem': 'Тотем тики',
  'Ice Cream Cart': 'Тележка с мороженым',
  'Hot Spring': 'Горячий источник',
  'Mini Ferris Wheel': 'Мини-колесо обозрения',
  'Palm Tree': 'Декоративная пальма',
  'Hydrangea Bush': 'Куст гортензии',
  'Mossy Rock': 'Замшелый камень',
  'Lily Pond': 'Пруд с кувшинками',
  'Cherry Blossom': 'Цветущая вишня',
  'Bamboo Grove': 'Бамбуковая роща',
  'Coral Piece': 'Коралловая фигурка',
  'Old Banyan': 'Старый баньян',
  'Shell Path': 'Тропинка из ракушек',
  'Stone Path': 'Каменная дорожка',
  'Boardwalk': 'Деревянный настил',
  'Brick Path': 'Кирпичная дорожка',
  'Storehouse': 'Склад',
  'Scarecrow': 'Пугало',
  'Pet House': 'Домик питомца',
  'Fishing Pier': 'Рыбацкий причал',
  'Fish Market': 'Рыбный рынок',
  'Workshop': 'Мастерская',

  // ── одежда
  'Fair Skin': 'Светлая кожа',
  'Tan Skin': 'Загорелая кожа',
  'Deep Skin': 'Смуглая кожа',
  'Brown Crop': 'Каштановая стрижка',
  'Black Long': 'Длинные чёрные',
  'Gold Ponytail': 'Золотой хвост',
  'Pink Curls': 'Розовые кудри',
  'Blue Spikes': 'Синие шипы',
  'Teal Buns': 'Бирюзовые пучки',
  'Silver Waves': 'Серебристые волны',
  'Smile': 'Улыбка',
  'Wink': 'Подмигивание',
  'Grin': 'Широкая улыбка',
  'Cool': 'Крутой взгляд',
  'Shy': 'Застенчивость',
  'Cat Mouth': 'Кошачий ротик',
  'Sky Tee': 'Небесная футболка',
  'Coral Tee': 'Коралловая футболка',
  'Tang Jacket': 'Праздничный жакет',
  'School Uniform': 'Школьная форма',
  'Star Swimsuit': 'Блестящий купальник',
  'Blue Suit': 'Синий костюм',
  'Aloha Shirt': 'Гавайская рубашка',
  'Cream Hoodie': 'Кремовая толстовка',
  'Pirate Coat': 'Пиратский плащ',
  'Sakura Yukata': 'Юката с сакурой',
  'Royal Garb': 'Королевский наряд',
  'Khaki Shorts': 'Шорты хаки',
  'Jeans': 'Джинсы',
  'Floral Skirt': 'Юбка в цветочек',
  'Overalls': 'Комбинезон',
  'Slacks': 'Брюки',
  'Grass Skirt': 'Травяная юбка',
  'Straw Hat': 'Соломенная шляпа',
  'Ball Cap': 'Бейсболка',
  'Flower Crown': 'Венок',
  'Pirate Hat': 'Пиратская шляпа',
  'Tiny Crown': 'Маленькая корона',
  'Shark Hood': 'Капюшон-акула',
  'Red Scarf': 'Красный шарф',
  'Round Glasses': 'Круглые очки',
  'Shell Necklace': 'Ожерелье из ракушек',
  'Fairy Wings': 'Крылья феи',
  'Shoulder Parrot': 'Попугай на плече',

  // ── питомцы
  'Coco Puppy': 'Кокосовый щенок',
  'Scares away a beast every 2 hours': 'Каждые 2 часа прогоняет зверя',
  'Salt Kitten': 'Солёный котёнок',
  'Rare fish bite chance +15%': 'Шанс поклёвки редкой рыбы +15%',
  'Sweet Bunny': 'Сладкий кролик',
  'Energy regen +10%': 'Восстановление энергии +10%',
  'Truffle Piglet': 'Поросёнок-кладоискатель',
  'Brings back a beach gift daily': 'Каждый день приносит подарок с пляжа',
  'Rainbow Parrot': 'Радужный попугай',
  'Fetches a faraway gift daily': 'Каждый день приносит подарок издалека',
  'Slowpoke Turtle': 'Черепашка-тихоня',
  'Snow Fox': 'Снежная лиса',
  'Cove Dolphin': 'Дельфин из бухты',

  // ── задания
  'Fresh Off the Boat': 'Только с корабля',
  'Plant 2 carrot seeds to begin island life.': 'Посадите морковь на 2 грядках, чтобы начать жизнь на острове.',
  'A Little Water': 'Капелька воды',
  'Water crops twice to speed them up.': 'Полейте растения 2 раза: так они растут быстрее.',
  'First Harvest': 'Первый урожай',
  'Harvest carrots 2 times.': 'Соберите морковь 2 раза.',
  'Small Business': 'Маленький бизнес',
  'Sell 3 items at the shop.': 'Продайте 3 предмета в магазине.',
  'Break New Ground': 'Новые земли',
  'Till 2 new plots.': 'Вспашите 2 новые грядки.',
  'Tidy Isle': 'Чистый остров',
  'Clear 2 weeds.': 'Уберите 2 сорняка.',
  'Cluck Cluck': 'Ко-ко-ко',
  'Buy a hen, feed her, and collect an egg.': 'Купите курицу, покормите её и соберите яйцо.',
  'Gone Fishing': 'На рыбалке',
  'Catch 2 fish at the shore.': 'Поймайте 2 рыбы на берегу.',
  'Home Sweet Home': 'Дом, милый дом',
  'Place 3 buildings or decorations.': 'Поставьте 3 постройки или украшения.',
  'Isle Defender': 'Защитник острова',
  'Drive off 1 invading beast.': 'Прогоните одного вторгшегося зверя.',
  'Fresh Look': 'Новый образ',
  'Buy a clothing item and change your outfit.': 'Купите одежду и смените наряд.',
  'Neighborly Visit': 'Визит к соседу',
  'Visit a neighbor’s island.': 'Навестите остров соседа.',
  'Helping Hand': 'Рука помощи',
  'Help a neighbor 3 times (water/weed/chase).': 'Помогите соседу 3 раза (полив, прополка, прогон зверей).',
  'Harmless Fun': 'Безобидная шалость',
  'Prank a neighbor once—the other road to fame.': 'Подшутите над соседом один раз: это другой путь к славе.',
  'Furry Friend': 'Пушистый друг',
  'Adopt a pet and play with it.': 'Заведите питомца и поиграйте с ним.',
  'A Bigger World': 'Мир побольше',
  'Expand your island for the first time.': 'Расширьте остров в первый раз.',
  'Daily Harvest': 'Урожай дня',
  'Harvest crops 10 times.': 'Соберите урожай 10 раз.',
  'Watering Pro': 'Мастер полива',
  'Water 8 times.': 'Полейте растения 8 раз.',
  'Three Casts': 'Три заброса',
  'Catch 3 fish.': 'Поймайте 3 рыбы.',
  'Feeding Time': 'Время кормёжки',
  'Feed animals 5 times.': 'Покормите животных 5 раз.',
  'Kind Islander': 'Добрый островитянин',
  'Help neighbors 5 times.': 'Помогите соседям 5 раз.',
  'Good Business': 'Выгодная торговля',
  'Earn 500 coins.': 'Заработайте 500 монет.',
  'Isle Patrol': 'Патруль острова',
  'Defeat 2 beasts.': 'Прогоните 2 зверей.',
  'Weeding Duty': 'Прополка',
  'Clear 4 weeds (yours or neighbors’).': 'Уберите 4 сорняка (у себя или у соседей).',
  'Sowing Season': 'Пора сева',
  'Plant 12 seeds.': 'Посейте 12 раз.',
  'Prankster Heart': 'Дух шутника',
  'Pull 2 pranks.': 'Устройте 2 шалости.',
  'Pet Time': 'Время с питомцем',
  'Feed or play with pets 3 times total.': 'Покормите питомцев или поиграйте с ними в сумме 3 раза.',
  'Ranch Rounds': 'Обход фермы',
  'Collect animal goods 6 times.': 'Соберите продукцию животных 6 раз.',

  // ── достижения
  'Harvest Master': 'Мастер урожая', 'Total harvests': 'Всего собрано урожаев',
  'Sower': 'Сеятель', 'Total plantings': 'Всего посадок',
  'Irrigation Engineer': 'Инженер-ирригатор', 'Total waterings': 'Всего поливов',
  'Angler': 'Рыболов', 'Total fish caught': 'Всего поймано рыбы',
  'Deep Sea Legend': 'Легенда глубин', 'Rare+ fish caught': 'Поймано редкой рыбы и выше',
  'Beast Bane': 'Гроза зверей', 'Beasts defeated': 'Прогнано зверей',
  'Rancher': 'Скотовод', 'Animal goods collected': 'Собрано продукции животных',
  'Isle Designer': 'Дизайнер острова', 'Buildings placed': 'Поставлено построек и украшений',
  'Isle Fashionista': 'Модник острова', 'Clothes bought': 'Куплено одежды',
  'Social Butterfly': 'Душа компании', 'Neighbor visits': 'Визитов к соседям',
  'Island Samaritan': 'Добрый самаритянин', 'Help actions': 'Действий помощи',
  'Trickster': 'Проказник', 'Pranks pulled': 'Устроено шалостей',
  'Weed Whacker': 'Победитель сорняков', 'Weeds cleared': 'Убрано сорняков',
  'Coin Mountain': 'Гора монет', 'Coins earned': 'Заработано монет',
  'Trade Tycoon': 'Торговый магнат', 'Items sold': 'Продано предметов',
  'Pet Whisperer': 'Друг питомцев', 'Pet feeds': 'Кормлений и игр с питомцами',
  'Quest Fiend': 'Охотник за заданиями', 'Quests completed': 'Выполнено заданий',
  'Pioneer': 'Первопроходец', 'Island expansions': 'Расширений острова',
  'Foreman': 'Прораб', 'Neighbors hired': 'Нанято соседей',
  'True Islander': 'Настоящий островитянин', 'Days played': 'Дней в игре',

  // ── соседи и их реплики
  'Auntie Haitang': 'Тётушка Хайтан',
  'You came! Fresh taro cake on the stove—take some.': 'Пришли! На плите свежий пирог из таро — возьмите кусочек.',
  'These old bones just love tending the fields.': 'Мои старые кости просто обожают возиться на грядках.',
  'Good child, Auntie remembers your kindness.': 'Добрый вы человек, тётушка вашу доброту не забудет.',
  'My, harder-working than my own family!': 'Ой, да вы трудолюбивее моей родни!',
  'Which little monkey is messing up my garden!': 'Какая это обезьянка хулиганит на моём огороде!',
  'Maodan': 'Маодань',
  'Heh, guess whose island I put a frog on yesterday?': 'Хе-хе, угадай, кому на остров я вчера подбросил лягушку?',
  'So bored. Fishing contest?': 'Скукотища. Устроим соревнование по рыбалке?',
  'Not bad, you’re alright!': 'Неплохо, ты молодец!',
  'Hey! Pranking is MY specialty!': 'Эй! Шалости — это МОЯ специальность!',
  'Xiaoman': 'Сяомань',
  'Ah... h-hello. The strawberries are almost ripe. So happy.': 'Ой... з-здравствуйте. Клубника почти созрела. Так радостно.',
  'The sea breeze smells sweet today.': 'Сегодня морской ветер пахнет сладко.',
  'Thank you... please take this shell.': 'Спасибо... возьмите эту ракушку.',
  'Sniff... my flowers...': 'Хлип... мои цветочки...',
  'Old Captain': 'Старый капитан',
  'Kid, there’s a big one in the western trench. Believe it?': 'Малый, в западной впадине сидит громадина. Веришь?',
  'Back in my day, one cast hauled up half a boat of moonlight.': 'В мои годы одним забросом я вытаскивал пол-лодки лунного света.',
  'Good sailor! Worth a cup of coconut wine.': 'Славный моряк! Заслужил чашку кокосового вина.',
  'Who touched my deck?!': 'Кто трогал мою палубу?!',
  'Atao': 'Атао',
  'Nice waves! One more ride, then watering.': 'Отличные волны! Ещё один заезд, и пойду поливать.',
  'Coconuts only taste right from the tallest tree.': 'Кокосы вкусны только с самой высокой пальмы.',
  'Solid! I’ll teach you to surf sometime.': 'Здорово! Как-нибудь научу тебя сёрфингу.',
  'Don’t prop tables with my surfboard!': 'Не подпирай стол моей доской для сёрфинга!',
  'Lingdang': 'Линдан',
  'Welcome! Today’s special: smiles are free!': 'Добро пожаловать! Сегодня акция: улыбки бесплатно!',
  'Your island keeps getting prettier. Learned from me, right?': 'Твой остров всё красивее. Это ты у меня научился, да?',
  'On the books—discount next time!': 'Записала в тетрадь — в следующий раз скидка!',
  'You break it, you buy it!': 'Сломал — плати!',
  'Mumu': 'Муму',
  'Shh—the pumpkins are growing. Listen.': 'Тсс — тыквы растут. Слышишь?',
  'I named my scarecrow Wednesday.': 'Я назвала своё пугало Средой.',
  'Wednesday says thanks too.': 'Среда тоже благодарит.',
  'Wednesday is very upset.': 'Среда очень расстроена.',
  'Beibei': 'Бэйбэй',
  'Meow~ my cat says your luck is good today.': 'Мяу~ моя кошка говорит, что тебе сегодня повезёт.',
  '38 shell types collected—2 more to go!': 'Собрала 38 видов ракушек — осталось всего 2!',
  'You’re kind—cats can tell.': 'Ты добрый — кошки это чувствуют.',
  'Cats, attack! ...Just kidding.': 'Кошки, в атаку! ...Шучу.',

  // ── редкость (панель коллекций)
  'Common': 'Обычная',
  'Uncommon': 'Необычная',
  'Rare': 'Редкая',
  'Epic': 'Эпическая',
  'Legendary': 'Легендарная',
};
